import request from '@/util/request'


export const usersList = (data) => request.post('/api/usersList', data);  //列表

export const usersAdd = (data) => request.post('/api/usersAdd', data);  //用户添加

export const usersEdit = (data) => request.post('/api/usersEdit', data);  //用户编辑

export const usersDel = (data) => request.post('/api/usersDel', data);  //用户删除

export const usersUpdStatus = (data) => request.post('/api/usersUpdStatus', data);  //更新状态

export const usersResetpwd = (data) => request.post('/api/usersResetpwd', data);  //重置密码

export const usersDetail = (data) => request.post('/api/usersDetail', data);  //详情